import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { withStyles } from '@mui/styles';
import { Controller } from 'react-hook-form';

const CustomTextField = withStyles({
  root: {
    '& .MuiInputBase-root': {
      fontFamily: 'inherit !important',
      '& input': {
        height: '12px',
        padding: '16px 12px',
        backgroundColor: 'white',
        fontSize: '0.875rem',
      },
      '& textarea': {
        lineHeight: '24px',
        '&::placeholder': {
          position: 'relative',
          top: '-1px',
        },
      },
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#75C4C8',
      },
      '& fieldset': {
        borderColor: '#EEEEEE',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#75C4C8',
      },
    },
    '& .MuiFormHelperText-root': {
      display: 'inline',
      textAlign: 'right',
      fontFamily: 'inherit !important',
      fontSize: '0.625rem',
      margin: '3px 5px 0',
    },
  },
})(TextField);

const UiTextField = forwardRef(({ name, control, ...rest }, ref) => {
  if (name && control)
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <CustomTextField
            ref={ref}
            name={name}
            error={!!error}
            helperText={error ? error.message : null}
            variant='outlined'
            fullWidth
            {...field}
            {...rest}
          />
        )}
      />
    );

  return (
    <CustomTextField
      ref={ref}
      name={name}
      variant='outlined'
      fullWidth
      {...rest}
    />
  );
});

UiTextField.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
};

export default UiTextField;
